import { CmsOffer } from '../../../../types/cmsProduct';
import { filterGiftsByAmountAndTenure } from '../../../../utils/helpers';
import { getMaxGiftPriceFromGiftList } from '../../../../utils/helpers/calculateRewardValue';

/** What one offer rewards at a loan amount and tenure (CMS-2023 §2.2). */
export type OfferReward =
  | { kind: 'none' }
  | { kind: 'noFixedValue' }
  | { kind: 'value'; value: number };

// Highest effective value (price minus top-up, as elsewhere on the site) among
// the offer's gifts matching the amount and tenure. Matching gifts without a
// set cash value (e.g. a percentage) → `noFixedValue`.
export const getOfferReward = (
  offer: CmsOffer,
  amount: number,
  tenure: number,
): OfferReward => {
  const { matchingAmountTenure } = filterGiftsByAmountAndTenure(
    offer.list_of_gifts,
    amount,
    tenure,
  );
  if (matchingAmountTenure.length === 0) return { kind: 'none' };

  const value = getMaxGiftPriceFromGiftList(matchingAmountTenure);
  return value > 0 ? { kind: 'value', value } : { kind: 'noFixedValue' };
};
